export default function ChevronRightIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="34" height="34" fill="transparent" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.0859 17L13.293 10.2071L14.7072 8.79292L22.2072 16.2929L22.9143 17L22.2072 17.7071L14.7072 25.2071L13.293 23.7929L20.0859 17Z"
        fill="currentColor"
      />
    </svg>
  );
}
